import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import {
  DataResponse,
  UpsertZendeskIntegrationResponseDataSchema,
  UpsertZendeskIntegrationSchema,
} from "schema"
import { z } from "zod"
import { zendeskIntegrationQueryKey } from "../../lib/zendesk/zendeskIntegrationQuery"

type Response = DataResponse<z.infer<typeof UpsertZendeskIntegrationResponseDataSchema>>

export function useUpsertZendeskIntegrationMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: z.infer<typeof UpsertZendeskIntegrationSchema>) => {
      const response = await axios.post<Response>(`/integrations/zendesk`, data)

      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: zendeskIntegrationQueryKey })
    },
  })
}
